import { render } from "./WistiaComponent.vue?vue&type=template&id=5fde9518"
import script from "./WistiaComponent.vue?vue&type=script&lang=js"
export * from "./WistiaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__